export enum Color {
  Red = "red",
  Orange = "orange",
  Green = "green",
  Blue = "blue",
  Yellow = "yellow",
  White = "white"
}
